import { render, staticRenderFns } from "./v-toggle.vue?vue&type=template&id=b544f0aa&scoped=true&"
import script from "./v-toggle.vue?vue&type=script&lang=js&"
export * from "./v-toggle.vue?vue&type=script&lang=js&"
import style0 from "./v-toggle.vue?vue&type=style&index=0&id=b544f0aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544f0aa",
  null
  
)

export default component.exports